import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
    overlayActive: boolean,
}

const initialState: UIState = {
    overlayActive: false,
}

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setOverlayActive: (state, action: PayloadAction<boolean>) => {
            state.overlayActive = action.payload;
        },
    },
    selectors: {
        getOverlayActive: (state) => state.overlayActive,
    }
})

export const {
    setOverlayActive,
} = uiSlice.actions;

export const {
    getOverlayActive,
} = uiSlice.selectors;

export default uiSlice;